export const TABLET_BREAKPOINTS = ["xSmall", "smallMedium"] as const;
export const TABLET_MAX_CHARACTERS = 64;
export const DESKTOP_MAX_CHARACTERS = 36;
export const VALUES_SEPARATOR = " · ";
export const SEPARATOR_LENGTH = VALUES_SEPARATOR.length;
export const DEFAULT_STICK_KEY = "ProductFlavours_DEFAULT";

export const PRODUCT_CATEGORY_V1 = "PloomDevice";
export const PRODUCT_CATEGORY_V2 = "Product";

export const BRAND_LABELS = {
  ProductFlavours: "EVO",
  ProductFlavoursLYO: "LYO",
} as const;

export type BrandLabelKey = keyof typeof BRAND_LABELS;
